import React, { Component } from 'react'

class InsightcareLocalFooter extends Component {
  render() {
    return (
      <footer className={'footerLocal ' + this.props.theme}>
        <div id="current-local" className={'text-right ' + this.props.theme}>
					<p>{this.props.hospitalName}</p>
        </div>
      </footer>
    )
  }
}

export default InsightcareLocalFooter
